/**
 * Normalizes profile picture fields from the API or localStorage for use as
 * img/Avatar `src`. Objects coerce to the string "[object Object]" in the DOM,
 * which triggers broken requests (e.g. CRA proxy /[object%20Object]).
 */
export function pictureUrlToString(picture) {
  if (picture == null) return '';
  if (typeof picture === 'string') return picture;
  if (typeof picture === 'object' && typeof picture.url === 'string') return picture.url;
  return '';
}
